import React, { lazy, Suspense, useEffect } from 'react';
import './App.css';
import { Toaster } from './components/ui/sonner';
import { LanguageProvider } from './contexts/LanguageContext';
import Navigation from './components/Navigation';
import Hero from './components/Hero';

const Problem = lazy(() => import('./components/Problem'));
const Solution = lazy(() => import('./components/Solution'));
const CaseStudies = lazy(() => import('./components/CaseStudies'));
const Testimonials = lazy(() => import('./components/Testimonials'));
const CTA = lazy(() => import('./components/CTA'));
const Footer = lazy(() => import('./components/Footer'));

// ============================================
// SCHAKELAAR VOOR CASESTUDIES SECTIE
// Zet op 'true' om casestudies weer te tonen
// Zet op 'false' om ze te verbergen
// ============================================
const TOON_CASESTUDIES = false;

const JSON_LD_DATA = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "name": "Systemise",
  "url": "https://systemise.be",
  "description": "Systemise automatiseert bedrijfsprocessen voor coaches en consultants. Leadgeneratie, verkoop, marketing en fulfillment.",
  "areaServed": { "@type": "Country", "name": "Belgium" },
  "serviceType": ["Business Automation", "Lead Generation", "Sales Automation", "Marketing Automation"],
  "inLanguage": ["nl", "en"],
  "knowsLanguage": ["nl", "en"],
  "contactPoint": {
    "@type": "ContactPoint",
    "email": "rozario@systemise.be",
    "contactType": "customer service",
    "availableLanguage": ["Dutch", "English"]
  }
});

function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON_LD_DATA;
    document.head.appendChild(script);
    return () => script.remove();
  }, []);

  return (
    <LanguageProvider>
      <div className="App">
        <Navigation />
        <Hero />
        <Suspense fallback={<div className="min-h-[200px]" />}>
          <Problem />
          <Solution />
          {TOON_CASESTUDIES && <CaseStudies />}
          <Testimonials />
          <CTA />
          <Footer />
        </Suspense>
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;